import { ListItem, ListItemText, Collapse, Box, ListItemProps, Typography } from '@material-ui/core'
import { FC, Fragment, ReactNode } from 'react'
import styled from 'styled-components'
//@ts-ignore
import { useTheme } from 'styled-components'
import {
  StyledDivider,
  StyledDrawerClosedIcon,
  StyledDrawerList,
  StyledDrawerOpenIcon,
  StyledListComponent,
  StyledListItemText
} from 'pages/profile/styled'
import { observer } from 'mobx-react'
import { accountSettingsStoreState } from 'models/account-settings/account-settings.store'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Button } from 'common/atoms/Button/Button'
import { useHistory } from 'react-router-dom'

const StyleDrawer = styled(Box)<{ isDevice?: boolean }>`
  && {
    top: ${props => (props.isDevice ? '34px' : '-80px')};
    width: ${props => (props.isDevice ? '100%' : '909px !important')};
    border-radius: 24px;
  }
`
const StyledButton = styled(Button)`
  && {
    &:hover {
      background-color: transparent;
      color: inherit;
      box-shadow: none;
    }
  }
`
const StyledTypographyHeader = styled(Typography)`
  && {
    color: ${props => props.theme.colors.accent1};
    text-align: center;
    margin-top: 24px;
    margin-bottom: 16px;
  }
`
const StyledListItem = styled(ListItem)<{ openParents?: boolean[]; index?: number }>`
  && {
    padding: 6px 39px 14px;
    display: flex;
    border-radius: ${props => (props.openParents[props.index] ? '24px 24px 0px 0px' : '24px')};
    background-color: ${props => props.theme.colors.supplementary};
    margin-bottom: 12px;
    &:hover {  background-color: ${props => props.theme.colors.supplementary}}
  }
`
const StyledIconBox = styled(Box)`
  && {
    margin-top: 20px;
    margin-bottom: 16px;
    align-items: center;
  }
`
const StyledHeaderBox = styled(Box)`
  && {
    display: flex;
    flex-direction: row;
    grid-gap: 10px;
    padding-left: 39px;
  }
`

export const CustomListItem: FC<ListItemProps<'li', { button?: false }> & { button: false }> = props => {
  return <ListItem {...props} />
}

interface EditProfileDrawerProps {
  parentItems: {
    name: string
    children: ReactNode[]
    endAdornment?: ReactNode | any
  }[]
  title?: string
  icon?: any
}

const EditProfileDrawer: FC<EditProfileDrawerProps> = props => {
  const { parentItems, title, icon } = props
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const history = useHistory()

  const { openParents, handleParentClick } = accountSettingsStoreState

  return (
    <StyleDrawer isDevice={isDevice}>
      {isDevice && (
        <Box style={{lineHeight: 3}}>
          <StyledButton small design="secondary" onClick={() => history.goBack()}>
            BACK
          </StyledButton>
          <StyledHeaderBox>
            <StyledIconBox>{icon}</StyledIconBox>
            <StyledTypographyHeader variant="h6">{title}</StyledTypographyHeader>
          </StyledHeaderBox>
        </Box>
      )}
      <StyledDrawerList isDevice={isDevice}>
        {parentItems.map((parent, index) => (
          <Fragment key={index}>
            <StyledListItem index={index} openParents={openParents} button onClick={() => handleParentClick(index)}>
              {openParents[index] ? <StyledDrawerOpenIcon /> : <StyledDrawerClosedIcon />}
              <StyledListItemText
                primary={parent.name}
                primaryTypographyProps={{
                  variant: 'h6'
                }}
              />
              {parent?.endAdornment && <Box>{parent?.endAdornment}</Box>}
            </StyledListItem>
            {openParents[index] ? <StyledDivider isDevice={isDevice} /> : ''}
            {openParents && openParents[index] && parent.children && (
              <Collapse in={openParents[index]} timeout="auto" unmountOnExit>
                <StyledListComponent disablePadding>
                  {parent.children.map((child, childIndex) => (
                    <CustomListItem key={childIndex} button={false}>
                      <ListItemText primary={child} />
                    </CustomListItem>
                  ))}
                </StyledListComponent>
              </Collapse>
            )}
            {index !== parentItems.length - 1}
          </Fragment>
        ))}
      </StyledDrawerList>
    </StyleDrawer>
  )
}

export default observer(EditProfileDrawer)
